/**
 * The end of the beta (ADR 0083), an instant in ISO 8601. Null while the beta
 * runs: every account opened so far is a beta account. Set it the day the beta
 * closes; the accounts opened after it never wear the beta title.
 */
export const BETA_ENDS_AT = null;
/** What the beta testers are given: their pet, claimed from the achievement. */
export const BETA_PET_ITEM = 'glitch';
//# sourceMappingURL=beta.js.map